import React from 'react'
import { Box, Typography } from '@mui/material'
import { LenderDetails } from '../../../ApplicationForm/ApplicationFormContext'
import { sanitizeLenderName } from '../../../../utils/utils'
import { LENDER_ICONS } from '../../../Introductions/PrefillIntroduction/PrefillIntroductionV3/PrefillIntroductionV3'

interface LenderDetailsMessagingProps {
  lenderDetails?: LenderDetails
}

const renderLogo = (lenderDetails?: LenderDetails) => {
  if (!lenderDetails?.lenderName) return null
  const lenderName = lenderDetails.lenderName.toLowerCase()
  return LENDER_ICONS[lenderName] ?? null
}

const renderLenderInline = (lenderDetails?: LenderDetails) => {
  if (!lenderDetails?.lenderName) return null

  const logo = renderLogo(lenderDetails)

  if (logo) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          ml: 1
        }}
      >
        {logo}
      </Box>
    )
  }

  return (
    <Typography
      component="span"
      variant="bodyLarge"
      sx={{ fontWeight: 600, ml: 1 }}
    >
      {sanitizeLenderName(lenderDetails.lenderName)}
    </Typography>
  )
}

const renderBodyText = (lenderDetails: LenderDetails): JSX.Element => (
  <>
    Your decision with {renderLenderInline(lenderDetails)} is waiting for you.
  </>
)

const LenderDetailsMessaging: React.FC<LenderDetailsMessagingProps> = ({
  lenderDetails
}) => {
  if (!lenderDetails) return null

  return (
    <Box sx={{ px: 5 }}>
      <Typography variant="titleLarge" sx={{ mb: 1 }} component="p">
        We&apos;ve got your application 🎉
      </Typography>

      <Typography variant="bodyLarge" mt={2} mb={5} component="p">
        {renderBodyText(lenderDetails)}
      </Typography>
    </Box>
  )
}

export default LenderDetailsMessaging
